export default {
  LOCAL_STORAGE_KEYS: {
    ethBlocksTxs: 'eth-blocks-txs-store'
  },
  VERSION: {
    ethBlocksTxs: '0.0.2'
  }
};
